<!--
 * @Description: 
 * @Autor: Ray7hw
 * @LastEditTime: 2020-10-20 15:30:25
-->
<template>
<body id="mainBody">
<div class="nrbj" >
</div>
<div class="login_bj">
</div>
<div class="login">
 
<h1>湖北华中文化产权交易所交易平台</h1>

<div class="w800">
<div class="left"><span style="margin-left: 50px;color: white;">官&nbsp;&nbsp;网：&nbsp;&nbsp;</span><a  href="http://www.hbcpre.com" target="blank" style="text-decoration: none;"><span  class="b">www.hbcpre.com</span></a> <br><span style="margin-left: 49px;color: white;"> 电&nbsp;&nbsp;话：&nbsp;&nbsp;
  </span><span style="margin-left: -4px;color: white;">  国有产权交易 &nbsp;&nbsp;027-88712339</span> <br><span style="margin-left: 106px;color: white;"> 行政事业资产交易&nbsp;&nbsp;027-88712338 </span></div>
<div class="right">
   <div style=" float: right; margin: 6px;" @click="gokbm"><img src="../../assets/images/cancel.png" title="返回首页" style="
    margin: -77px -59px 0px 34px;
"></div>
<h2 class="title">华中文交所报名及结算系统</h2>
<div class="input" style="width: 445px; margin: 0 auto;">
<label class="js-name" style="position: relative;float: left; width: 70%; height: 46px; background: #fff; border: 1px solid #dcdcdc; margin-bottom: 30px;">
<em style="float: left;width: 40px; height: 20px; line-height: 20px; margin-top: 13px;border-right: #eee 1px solid;margin-right: 12px; text-align: center;">
<img src="../../assets/images/icon_01.png" width="16" height="16"></em>
<input  type="text" placeholder="请输入用户名/手机号"  v-model="name_phone" style="    width: 70%;height: 42px;line-height: 42px;border: 1px solid #fff;
 background: #fff;font-size: 14px;box-sizing: border-box;">
       
 <p class="error js-error">
 <i style="color:red"></i>
 </p>
 </label>
 <label class="js-password" style="position: relative;float: left; width: 70%;height: 46px; background: #fff;border: 1px solid #dcdcdc; margin-bottom: 30px;">
 <em style="float: left;width: 40px; height: 20px;line-height: 20px; margin-top: 13px;border-right: #eee 1px solid;margin-right: 12px;text-align: center;">
 <img src="../../assets/images/icon_02.png" width="16" height="20">
 </em>
 <input type="password" placeholder="请输入密码"   v-model="password" show-password  style="     width: 70%; height: 42px; line-height: 42px; border: 1px solid #fff; background: #fff;font-size: 14px;box-sizing: border-box;">
 <p class="error js-error"><i style="color:red"></i></p></label><label class="js-code" style="position: relative; float: left; width: 40%; height: 46px;  background: #fff; border: 1px solid #dcdcdc;  margin-bottom: 30px;"><em style="float: left; width: 40px; height: 20px;line-height: 20px; margin-top: 13px; border-right: #eee 1px solid;
 margin-right: 12px; text-align: center;">
 <img src="../../assets/images/icon_03.png" width="18" height="20"></em><input class="js-input"   v-model="yzm"
              placeholder="请输入验证码"   @keyup.enter="onSubmit" type="text" style="float: left; width: 58%; height: 42px; line-height: 42px; margin-top: 2px; border: none;">
 

 <p class="error js-error"><i style="color:red"></i></p></label>  
      <div
            style="color:#f2f0f2"
            
          >11</div>
       <div style="margin: 142px 0 0 0;">
            <s-identify :identifyCode="identifyCode"></s-identify> <label style="margin:0 0 0 110px" @click="refreshCode" > 换一张</label>
          </div>
   
    
 <div class="btn js-login" style="display: inline-block; width: 70%; height: 38px; line-height: 38px;  background: #fe8c04;
   border-radius: 1px;font-size: 14px;color: #fff;text-align: center; border: none;"  @click="onSubmit">登录</div>
       
   </div>
         <div class="login-re" style="margin:10px auto;">
        <div
          @click="goProtocol"
          class="login-re-1"
        >免费注册</div>
      <div  class="login-re-2">
      <a href="https://mp.weixin.qq.com/s/Rs2iQhLtmTkUVXQ0Aw69QA" target="_blank">报名指南</a>
     </div>
        <div
          class="login-re-2"
          @click="goforget"
        >找回密码</div>
      </div>

      <div class="login-ti"></div>
   </div>
   </div>
   </div>
   </body>
</template>

<script>
import SIdentify from '@/components/s-identify'
import  "../../assets/font/login.css"
export default {
  components: {
    SIdentify
  },
  data () {
    return {
      name_phone: '',
      password: '',
      yzm: '',
      identifyCode: '',
      identifyCodes: '1234567890',
      openid: '',
      userId: '',
      userType: '',
      proId: '',
    };
  },
  mounted () {
    // localStorage.setItem("token", '888');
    this.createCode()
  },
  created () {
    var lett = this;
    document.onkeydown = function (e) {
      var key = window.event.keyCode;
      if (key == 13) {
        lett.onSubmit();
      }
    }
    // this.identifyCode = Math.floor(Math.random() * 10)
  },

  methods: {

    createCode () {
      var code = '';
      //设置长度，这里看需求，我这里设置了4
      var codeLength = 4;

      //设置随机字符
      var random = new Array(0, 1, 2, 3, 4, 5, 6, 7, 8, 9);

      //循环codeLength 我设置的4就是循环4次
      for (var i = 0; i < codeLength; i++) {
        //设置随机数范围,这设置为0 ~ 36
        var index = Math.floor(Math.random() * 9);

        //字符串拼接 将每次随机的字符 进行拼接
        code += random[index];
      }

      //将拼接好的字符串赋值给展示的code
      this.identifyCode = code;
    },

    randomNum (min, max) {
      return Math.floor(Math.random() * (max - min) + min)
    },
    refreshCode () {
      this.identifyCode = ''
      this.makeCode(this.identifyCodes, 4)
    },
    makeCode (o, l) {
      for (let i = 0; i < l; i++) {
        this.identifyCode += this.identifyCodes[
          this.randomNum(0, this.identifyCodes.length)
        ]
      }
    },
    //登录
    onSubmit () {
      if (this.name_phone == '' || this.password == '') {
        this.$message.error('请先填写用户名和密码！');
        return
      }

      if (this.identifyCode != this.yzm) {
        this.$message.error('验证码错误，请重新填写！');
        return
      }


      let form = new FormData();
      form.append('userName', this.name_phone)
      form.append('password', this.password)

      this.$axios.post("user/login.do", form).then(res => {
        this.createCode()

        // console.log(res.data.code, 99)

        // console.log(res, 89)
        if (res.data.code == 200) {

          console.log(res, 99)
          // this.$router.push({ path: '/layout/index/', query: { userName: res.data.data.userName } })
          // this.$router.push({ path: './layout/index/', query: { userName: res.data.data.userName } })
          this.$message({
            message: '登录成功',
            type: 'success',
            during: 2000
          })
          // this.$router.push({ path: '/layout/index/', query: query: { userinfo: this.info.pro, res: this.info.res } })
          // this.$router.push(
          //   {
          //     path: '/layout/index/',
          //     query: { userinfos: res.data.data }
          //   })
          this.userId = res.data.data.userId
          this.userType = res.data.data.userType
          localStorage.setItem('userId', this.userId)
          localStorage.setItem('userType', this.userType)
          localStorage.setItem('userName', this.name_phone)
          localStorage.setItem('typeName', res.data.data.typeName)
          localStorage.setItem('phone', res.data.data.phone)
          // localStorage.setItem('typeName', res.data.data.typeName)
          let token = res.data.data.token
          // console.log(token, 77)
          let token1 = localStorage.setItem('token', token)
          this.$store.commit('set_userName', res.data.data.userName)

          if (token1 == '') {
            this.$message({
              message: res.data.message,
              type: 'warning'
            });
            // this.goProtocol()
          }
          // this.$router.push('/layout/index/?userid=' + this.userId)
          // this.$router.push({ path: '/layout/index/', query: { userId: this.userId } })
          if (localStorage.getItem('proId')) {
          //  alert('projs')
          //  this.active('2')
            this.$router.push({ path: '/layout/projectRegistration?id='+localStorage.getItem('proId') })
            this.$store.commit("add", '2');
          } else {
          //  alert('else')
            this.$router.push({ path: '/layout/index?n=1' })
            // this.$router.push({ path: '/layout/projectRegistration/' })
            this.$store.commit("add", '6');
          }


        } else {
          this.$alert(res.data.message, {
            confirmButtonText: '确定',
            title: '提示',
            callback: action => {
            }
          });
        }


      });
      // console.log(22);

    },

    //跳转注册协议
    goProtocol () {
      this.$router.push('/Protocol/')
    },
    //忘记密码
    goforget () {
      this.$router.push('/forgetpaw/')
    },
    gokbm () {
      this.$router.push('/layout/gokbm?n=10')
    }

  }


};
</script>


<style lang="less">
    body{font:14px/1.7 Arial,"Microsoft YaHei",Tahoma,Verdana,Helvetica, sans-serif;color:#666; background: #0a204d; }
   .nrbj {
  /*  background: url(/wcs/Tpl/member/default/image/login/bj.jpg) bottom repeat-x; */
    width: 100%;
    height: 100%;
    overflow: hidden;
    position: fixed;
    bottom: 0;
    z-index: -11;
}
   .login_bj {
    position: fixed;
    bottom: 0;
  /*  background: url(/wcs/Tpl/member/default/image/login/login.jpg) bottom center no-repeat; */
    height: 100%;
    width: 100%;
    z-index: -9;
}
   .login {
    width: 820px;
    margin: auto;
    overflow: hidden;
    z-index: 999;
}
   .login h1 {
    font-size: 36px;
    color: #b0caff;
    text-align: center;
    line-height: 80px;
    padding-top: 38px;
    overflow: hidden;
    font-weight: 400;
}
   .w800 {
    width: 800px;
    margin: auto;
    background: #f2f0f2;
    box-shadow: 0 0 10px #000;
    overflow: hidden;
    margin-top: 8px;
    margin-bottom: 10px;
}

.a_hover:hover{color: #f00;text-decoration: none;}
   .left {
    width: 400px;
    height: 109px;
    background: #2357c2 url("../../assets/images/left_tb.png") center 40px no-repeat;
    padding-top: 380px;
    color: #8daceb;
    float: left;
}
   .right {
    width: 300px;
    float: left;
    margin-top: 70px;
    margin-left: 50px;
}

  .right ul {
    padding: 0;
    margin: 0;
}
 .b{color:white}
 .b:hover{ color:red

 }
  .right h2 {
    text-align: center;
    font-size: 24px;
    color: #333;
    font-weight: 400;
    line-height: 30px;
    margin-bottom: 25px;
}
  .right ul li  {
    margin: 14px 0;
    position: relative;
}
 li {
    list-style: none;
}
     .login-b {
      width: 50%;
      padding: 18px 0;
      width: 50%;
      text-align: center;
      background-color: #a30001;
      // margin: 0 auto;
      color: #fff;
      margin: 52px auto 23px;
    }
    .login-b:hover {
      cursor: pointer;
    }
    .login-re {
      width: 88%;
      display: flex;
      margin: 0 auto;
      justify-content: space-between;
      .login-re-1 {
        text-decoration: none;
        font-size: 16px;
        
      }
      .login-re-2 {
        text-decoration: none;
        font-size: 16px;
      }
    }
    .login-re:hover {
      cursor: pointer;
    }

    .login-ti {
      font-size: 20px;
      color: #666666;
      text-align: center;
      padding-top: 10%;
      padding-bottom: 5%;
    } 

</style>






// WEBPACK FOOTER //
// src/pages/login/index.vue